/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ totalWords: NonNullable<unknown> }} Event_Metrics_Words_TitleInputs */



/**
* | output |
* | --- |
* | "{totalWords} Total Words" |
*
* @param {Event_Metrics_Words_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_words_title = /** @type {((inputs: Event_Metrics_Words_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Words_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.totalWords} Mots totaux`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.totalWords} Gesamtwörter`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.totalWords} Parole totali`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.totalWords} Всего слов`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.totalWords} Total de palabras`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.totalWords} 总字数`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.totalWords} 合計単語数`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.totalWords} कुल शब्द`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.totalWords} Total de palavras`)
	return /** @type {LocalizedString} */ (`${i?.totalWords} Total Words`)
});